import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {InsightsPanelComponent} from './insights-panel/insights-panel.component';

@Component({
    selector: 'app-house-details-overview',
    standalone: true,
    imports: [InsightsPanelComponent],
    templateUrl: './house-details-overview.component.html',
    styleUrl: './house-details-overview.component.scss'
})
export class HouseDetailsOverviewComponent implements OnInit {
    houseId: number | null = null;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.houseId = params['id'] ? +params['id'] : null;
        });
    }
}
